import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const SuccessCheck = ({ show, duration = 500 }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        // Component will be unmounted by parent
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [show, duration]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="success-check">
      <i className="fas fa-check"></i>
    </div>,
    document.body
  );
};

export default SuccessCheck;